import { stepName as initialStepName } from '../../../components/process/generic/Password/ChangePassword/View'
import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const initialState = {
  step: initialStepName
}

const ChangePassword = {
  namespaced: true,
  state: initialState,
  actions: {
    async changePassword ({ commit, state }, { changePasswordData, nextStep }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation changePassword ($changePasswordInput: ChangePasswordInput!) {
          changePassword (changePassword: $changePasswordInput) {
            success
          }
        }`,
        variables: {
          changePasswordInput: {
            oldPassword: changePasswordData.oldPassword,
            newPassword: changePasswordData.password
          }
        }
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'changePassword', { root: true })
        state.step = nextStep
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    reset (state) {
      Object.assign(state, initialState)
    },
    changeStep (state, { step }) {
      state.step = step
    }
  },
  getters: {
    currentStep: (state) => {
      return state.step
    }
  }
}

export {
  ChangePassword
}
